import { render, staticRenderFns } from "./Aboutyage.vue?vue&type=template&id=40908535&scoped=true"
import script from "./Aboutyage.vue?vue&type=script&lang=js"
export * from "./Aboutyage.vue?vue&type=script&lang=js"
import style0 from "./Aboutyage.vue?vue&type=style&index=0&id=40908535&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40908535",
  null
  
)

export default component.exports